import * as React from 'react';
import { FC } from 'react';
import { Link } from 'react-admin';

import FullNameField from './FullNameField';
import { FieldProps, Customer } from '../types';

const CustomerLinkField: FC<FieldProps<Customer>> = props =>
    props.record ? (
        <Link to={`/users/${props.record.id}`}>
            <FullNameField {...props} />
        </Link>
    ) : null;

CustomerLinkField.defaultProps = {
    source: 'user',
    addLabel: true,
};

export default CustomerLinkField;
